import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

const CAT_IMG = {
  pizza: "https://images.unsplash.com/photo-1513104890138-7c749659a591?w=800&q=80",
  burgers: "https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=800&q=80",
  "fish-chips": "https://images.unsplash.com/photo-1580217593608-61931cefc821?w=800&q=80",
  indian: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=800&q=80",
  steak: "https://images.unsplash.com/photo-1600891964092-4316c288032e?w=800&q=80",
  mexican: "https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=800&q=80",
  healthy: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=800&q=80",
  family: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=800&q=80",
  desserts: "https://images.unsplash.com/photo-1488477181946-6428a0291777?w=800&q=80",
  drinks: "https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=800&q=80",
};

const Categories = () => {
  const { t, cuisineLabel } = useLang();
  const [cats, setCats] = useState([]);
  useEffect(() => { api.get("/categories").then(r => setCats(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
      <h1 className="font-heading text-3xl sm:text-5xl font-extrabold text-navy tracking-tight">{t("categories")}</h1>
      <p className="mt-2 text-navy/60">{t("hungryFor")}</p>
      <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {cats.map((c, i) => (
          <Link
            key={c.key}
            to={c.key === "family" ? "/family-deals" : `/restaurants?cuisine=${c.key}`}
            data-testid={`cat-page-${c.key}`}
            className="relative aspect-square rounded-2xl overflow-hidden group animate-fade-up"
            style={{ animationDelay: `${i * 50}ms` }}
          >
            <img src={CAT_IMG[c.key]} alt={c.label} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy/80 via-navy/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <div className="text-3xl mb-2">{c.icon}</div>
              <div className="font-heading text-white font-bold text-lg">{cuisineLabel(c.key)}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Categories;
